
define('text!platform/commonUI/inspect/res/info-table.html',[],function () { return '<table>\n    <tr ng-repeat="property in ngModel">\n        <td class="label">{{property.name}}</td>\n        <td title="{{property.value}}" class="value align-{{property.align}}">\n            {{property.value}}\n        </td>\n    </tr>\n</table>\n';});

